// extracted by mini-css-extract-plugin
export var shake = "sponsor-module--shake--2aa93";
export var sponsor = "sponsor-module--sponsor--6a8c8";
export var sponsorImageWrapper = "sponsor-module--sponsor-image-wrapper--36199";
export var sponsorTxt = "sponsor-module--sponsor-txt--94e97";